<template>
  <div style="margin: 2em 2em 0.5em 2em;">
    <div class="box">
      <BInputText
        label-text="标题"
        class="flexstart"
        :required="true"
        v-model="addParams.messageName"
        :maxLength="20"
        placeholder="请输入标题"
      />
    </div>
    <div class="box1">
      <BInputPullDown
        label-name="对象"
        class="flexstart"
        :required="true"
        v-model="addParams.messageType"
        :Options="messageTypeList"
      />
    </div>
    <div class="box2">
      <label class="labelClass"
        >内容<span style="color:#FC1111;">*</span></label
      >
      <BInputTextArea
        class="area-class"
        v-model="addParams.content"
        placeholder="请输入内容"
        :maxLength="225"
      />
    </div>
    <div class="box1">
      <BInputPullDown
        label-name="启用标识"
        class="flexstart mr-em"
        :required="true"
        v-model="addParams.enableFlg"
        :Options="enableList"
      />
    </div>
    <div class="box1">
      <BInputDateTime 
        labelText = "启用时间" 
        placeholder = "请选择时间"
        :required="true"
        v-model="addParams.enableTime"
        @dateTimeChange="onDateTimeChange"
      />
    </div>  
    <div class="box2">
      <BBtnPrimary v-if="messageId == '0'" :clicked="handleAdd" btn-txt="保存" />
      <BBtnPrimary v-else :clicked="handleEdit" btn-txt="修改" />
      <BBtnPrimary :clicked="upConfirmSuccess" btn-txt="返回" />
    </div>
  </div>
</template>
<script>
import {
  add,
  updata,
  detail,
} from "@/api/message";
import BInputText from "../../components2/BInputText";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputTextArea from "../../components2/BInputTextArea";
import BInputDateTime from "../../components2/BInputDateTime";
import Vue from "vue";

export default {
  components: {
    BInputText,
    BBtnPrimary,
    BInputPullDown,
    BInputTextArea,
    BInputDateTime,
  },
  data: () => ({
    addParams: {
      messageName:'',
      messageType:'',
      content:'',
      enableFlg:'',
      enableTime:'',
    },
    items: [],
    checked: [],
    messageTypeList: [],
    enableList: [],
    messageId: "",
    versionId: null,
    navi: [{ name: "message-management" }, { name: "message-add" }],
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 页面初期化
      vm.messageId = vm.$route.params.id;
      if (
        vm.messageId !== undefined &&
          vm.messageId !== null &&
          vm.messageId !== ""
      ) {
        // 把不为空的参数存入缓存
        const storageParams = {
          messageId: vm.messageId,
        };
        vm.$store.commit("SET_MESSAGE_PARAMS", storageParams);
      }
      // 查询条件赋值
      if (
        vm.$store.state.message_messageId !== undefined &&
        vm.$store.state.message_messageId !== null &&
        vm.$store.state.message_messageId !== ""
      ) {
        vm.messageId = vm.$store.state.message_messageId;
      }
      vm.init();
    });
  },
  methods: {
    // 初始化
    async init() {
      var params = {
        id: this.messageId,
      };
      const data = await detail(params);
      this.addParams = data.data;
      this.messageTypeList = data.data.messageTypeList;
      this.enableList = data.data.enableList;
    },
    handleAdd() {
      if (!this.addParams.messageName) {
        Vue.prototype.$valertbar.show("请输入标题");
        return;
      }
      if (!this.addParams.messageType) {
        Vue.prototype.$valertbar.show("请选择对象");
        return;
      }
      if (!this.addParams.content) {
        Vue.prototype.$valertbar.show("请输入内容");
        return;
      }
      if (!this.addParams.enableFlg) {
        Vue.prototype.$valertbar.show("请选择启用标识");
        return;
      }
      if (!this.addParams.enableTime) {
        Vue.prototype.$valertbar.show("请选择发布时间");
        return;
      }
      if (new Date(this.addParams.enableTime).getTime() < new Date().getTime()) {
        Vue.prototype.$valertbar.show("发布时间必须是未来时间");
        return false;
      }
      this.add();
    },
    async add() {
      var param = {
        messageName: this.addParams.messageName,
        messageType: this.addParams.messageType,
        content: this.addParams.content,
        enableFlg: this.addParams.enableFlg,
        enableTime: this.addParams.enableTime.replace(' ', 'T'),
      };
      const data = await add(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.upConfirmSuccess();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    handleEdit() {
      if (!this.addParams.messageName) {
        Vue.prototype.$valertbar.show("请输入标题");
        return;
      }
      if (!this.addParams.messageType) {
        Vue.prototype.$valertbar.show("请选择对象");
        return;
      }
      if (!this.addParams.content) {
        Vue.prototype.$valertbar.show("请输入内容");
        return;
      }
      if (!this.addParams.enableFlg) {
        Vue.prototype.$valertbar.show("请选择启用标识");
        return;
      }
      if (!this.addParams.enableTime) {
        Vue.prototype.$valertbar.show("请选择发布时间");
        return;
      }
      if (new Date(this.addParams.enableTime).getTime() < new Date().getTime()) {
        Vue.prototype.$valertbar.show("发布时间必须是未来时间");
        return false;
      }
      this.edit();
    },
    async edit() {
      var param = {
        id:this.messageId,
        messageName: this.addParams.messageName,
        messageType: this.addParams.messageType,
        content: this.addParams.content,
        enableFlg: this.addParams.enableFlg,
        enableTime: this.addParams.enableTime.replace(' ', 'T'),
      };
      const data = await updata(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.upConfirmSuccess();
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    onDateTimeChange(value) {
        this.addParams.enableTime = value
    },
    upConfirmSuccess() {
      this.$router.push({
        name: "message-management",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.box1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
.box2 {
  display: flex;
  // align-items: center;
  margin-top: 30px;
}
.area-class {
  width: 540px;
  height: 120px;
}
.flexstart {
  justify-content: flex-start !important;
}
.mr-em {
  margin: 1em 0;
}
.labelClass {
  margin: 0 10px 0 20px;
  text-align: right;
  width: 65px;
}
</style>
